var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var SvgNft = function SvgNft(_ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M54.969 20.942H8.879v4.622h46.09v-4.622Z",
    className: "illustration-light-fill"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m56.43 23.84-.576-.44a1.419 1.419 0 0 1-.277-1.978l.437-.586c.711-.936.398-2.084-.42-3.048l-5.959-8.344a4.776 4.776 0 0 0-3.886-2.002H18.233c-1.543 0-2.99.746-3.886 2.002l-5.945 8.344c-.818.964-1.127 2.109-.42 3.048l.437.586a1.422 1.422 0 0 1-.277 1.977l-.576.441a2.126 2.126 0 0 0-.409 2.98L28.1 55.979c.313.409.797.65 1.313.65h5.166c.515 0 .999-.241 1.312-.65l20.953-29.16a2.126 2.126 0 0 0-.41-2.979h-.003ZM32.466 52.398a.594.594 0 0 1-.946 0L10.57 23.673c-.238-.313-.16-.768.072-1.077l6.624-9.284a2.97 2.97 0 0 1 2.425-1.248h24.6a2.98 2.98 0 0 1 2.425 1.248l6.635 9.284c.235.309.31.768.071 1.077l-20.96 28.725h.004Z",
    className: "illustration-light-fill"
  })));
};

export default SvgNft;